import React, { useEffect } from "react";
import style from "./Style.module.css";
import Nav from "../../Components/Nav";
import { Container } from "react-grid-system";
import SheetCard from "../../Components/SheetCard";
import Util from "../../Util";
import { withAlert } from "react-alert";
import { withRouter } from "react-router-dom";
import NotFoundImg from "../../asset/NotFoundSheet.png";

const Index = ({ alert }) => {
  const [loading, setLoading] = React.useState(true);
  const [sheets, setSheets] = React.useState();
  const [user, setUser] = React.useState({
    infoEnter: true,
  });

  const getTutoringData = async () => {
    try {
      const data = await Util.sendPost("/api/public/getOnlineTutorSheets", {
        search: "",
        filter: {
          store: 7,
        },
        sort: "-created",
        page: 0,
        pageLimit: 20,
        timeStamp: new Date().getTime(),
      });
      setSheets(data.data);
      setUser(data?.user);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getTutoringData();
  }, []);

  const addCart = async (id) => {
    var data = await Util.sendPost("/api/public/ownSheet", { id });
    if (data.success) {
      var res = await Util.addCart(id);
      if (res) alert.show("เพิ่มชีทลงตะกร้าสำเร็จ", { type: "success" });
      else alert.show("มีชีทนี้ในตะกร้าอยู่แล้ว", { type: "error" });
    } else {
      alert.show("คุณเป็นเจ้าของชีทนี้อยู่แล้ว", { type: "error" });
    }

    return true;
  };

  return (
    <React.Fragment>
      <div className={style.tutoringExamsPage}>
        <Nav current="tutoring-exams" user={user} />
        <Container>
          {loading ? <div key="loader" className={style.loader} /> : null}
          <div className={style.blanker} />
          <div className={style.blanker} />
          <div className={style.contentContainer}>
            <div className={style.bannerContainer}>
              <img
                className={style.bannerImage}
                src="/banner.png"
                alt="banner"
                onClick={() => {
                  this.props.history.push("/tutoring-exams");
                }}
              />
            </div>
            <div className={style.bigHeader}>
              รวมชีทสรุปวิชายอดฮิต พิชิตสนามสอบไฟนอลนี้!
            </div>

            <div className={style.fillbot}>
              <div className={style.sheetWrapper}>
                {sheets?.map((sheet, index) => (
                  <SheetCard
                    sheet={sheet}
                    index={index}
                    color={sheet.color}
                    addCart={addCart}
                  />
                ))}

                {(sheets ?? []).length === 0 && !loading ? (
                  <div className={style.notFoundSheet}>
                    <img src={NotFoundImg} alt="notFoundSheet" />
                    <h2>ยังไม่มีชีทสรุป</h2>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(withAlert()(Index));
